<!--中间左边-->
<template>
	<div class="middleRightBody">
		<div class="middleRightContent" :style="getBackgroudImageStyle('/huanbao/billboard/hyzb.png')">
			<div class="middleRightTitle" :style="getBackgroudImageStyle('/huanbao/billboard/title.png')">
				<span class="colorBlue">各行业企业异常占比</span>
			</div>
			<div class="middleRightTable">
				<ul class="ul1">
					<li>
						<span>企业名称</span>
						<span>行业</span>
						<span>停限产</span>
					</li>
				</ul>
				<ul class="ul2" id="ul2">
					<li v-for="item in dataList">
						<span class="colorBlue">{{item.unitName}}</span>
						<span class="colorBlue">{{item.industry}}</span>
						<span class="colorBlue">{{item.txc}}</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				dataList: [{
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}, {
					unitName: '珠海维度电气科技有限公司',
					industry: '其他',
					txc: '20%'
				}],
				elementById: undefined,
				scrollBar:1,//当前滚动条的位置
			}
		},
		created() {},
		mounted() {
			this.elementById = document.getElementById('ul2')
			setInterval(load=>{
				this.dataList.push(this.dataList[this.scrollBar])
				 /*this.dataList.splice(0,1)*/
				this.elementById.scrollTo(0,this.scrollBar)
				this.scrollBar+=1
			},100)
		},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			}
		},
		watch: {},
		methods: {}
	}
</script>

<style scoped>
	.middleRightBody {
		width: 25%;
		height: 100%;
		margin-right: 1%;
	}
	
	.middleRightContent {
		width: 100%;
		height: 99%;
	}
	
	.colorBlue {
		color: #309efe !important;
	}
	
	.middleRightTitle {
		width: 35%;
		height: 6%;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.middleRightTitle span {
		font-size: .16rem;
	}
	
	.middleRightTable {
		width: 98%;
		height: 92%;
		margin: 0 auto;
		margin-top: 1%;
	}
	.middleRightTable .ul1{
		width: 85%;
		margin: 0 auto;
		height: 10%;
	}
	.middleRightTable .ul2 {
		width: 85%;
		margin: 0 auto;
		height: 90%;
		overflow-x: hidden;
	}
	
	.middleRightTable .ul2::-webkit-scrollbar {
		display: none;
	}
	
	.middleRightTable ul li {
		width: 100%;
		display: flex;
		align-items: center;
		padding-top: .1rem;
		padding-bottom: .1rem;
	}
	
	.middleRightTable .ul2 li:nth-child(odd) {
		background-color: #0a225f;
	}
	
	.middleRightTable ul li span {
		color: white;
		display: block;
	}
	
	.middleRightTable ul li span:nth-child(1) {
		width: 50%;
		padding-left: 10%;
	}
	
	.middleRightTable ul li span:nth-child(2) {
		width: 20%;
	}
	
	.middleRightTable ul li span:nth-child(3) {
		width: 20%;
	}
</style>